document.addEventListener('DOMContentLoaded', () => {
  const progress = document.querySelector('.uk-progress'); // <progress> element

  if (!progress) {
    return;
  }
  

  function updateScrollProgress() {
    const scrollTop = window.scrollY;
    const docHeight = document.body.scrollHeight - window.innerHeight;
    const scrollPercent = docHeight > 0 ? (scrollTop / docHeight) * 100 : 0;

    progress.value = scrollPercent;
  }

  // Run on scroll + run once at load
  window.addEventListener('scroll', updateScrollProgress, { passive: true });
  updateScrollProgress();
});
